import moment from "moment";
import router from "../routes";

export const buildPropertyUrl = (id, date) => {
  const url = `/listing/${id}`;
  const params = new URLSearchParams({
    findAvailability: "true",
    showCalendar: "true",
  });

  const { checkIn, checkOut } = date;

  if (checkIn && checkOut) {
    params.set("checkIn", moment(checkIn, "DD MMM YYYY").format("YYYY-MM-DD"));
    params.set(
      "checkOut",
      moment(checkOut, "DD MMM YYYY").format("YYYY-MM-DD")
    );
  }

  const listId = router.currentRoute.query?.list_id;

  if (listId) {
    params.set("list_id", listId);
  }

  return `${url}?${params.toString()}`;
};

export const buildMapUrl = ({ latitude, longitude, filter = {} }) => {
  const params = new URLSearchParams();

  if (latitude && longitude) {
    params.set("latitude", latitude);
    params.set("longitude", longitude);
  }

  const listId = router.currentRoute.query?.list_id;
  if (listId) {
    params.set("list_id", listId);
  }

  if (filter.facilities) {
    params.append("facilities", filter.facilities);
  }

  if (filter.ratings) {
    params.append("ratings", filter.ratings);
  }

  if (filter.distributorType) {
    params.append("distributorType", filter.distributorType);
  }

  return `/listing_map?${params.toString()}`;
};
